__webpack_require__.p = "/proyecto/";